export const EM_CRIACAO = 'EM_CRIACAO';
export const AGUARDANDO_INSPECAO = 'AGUARDANDO_INSPECAO';
export const EM_INSPECAO = 'EM_INSPECAO';
export const INSPECAO_EM_ENVIO = 'INSPECAO_EM_ENVIO';
export const INSPECAO_ENVIADA_PARCIAL = 'INSPECAO_ENVIADA_PARCIAL';
export const INSPECAO_SYNC_ERROR = 'INSPECAO_SYNC_ERROR';
export const ERRO_AO_ENVIAR_INSPECAO = 'ERRO_AO_ENVIAR_INSPECAO';
export const INSPECAO_FINALIZADA = 'INSPECAO_FINALIZADA';
export const INSPECAO_ENVIADA_COM_SUCESSO = 'INSPECAO_ENVIADA_COM_SUCESSO';
export const AGUARDANDO_DIGITACAO = 'AGUARDANDO_DIGITACAO';
export const EM_DIGITACAO = 'EM_DIGITACAO';
export const DIGITACAO_FINALIZADA = 'DIGITACAO_FINALIZADA';
export const EXECUTADA_GDIS = 'EXECUTADA_GDIS';
export const FINALIZADA = 'FINALIZADA';
export const CANCELADA = 'CANCELADA';
export const EM_ANALISE = 'EM_ANALISE';

export const canDigitar = status => [INSPECAO_FINALIZADA, INSPECAO_ENVIADA_COM_SUCESSO, AGUARDANDO_DIGITACAO].indexOf(status) > -1;

/** Ordered keys for NsirStatusSelect and similar UI lists. */
export const NSIR_STATUS_OPTIONS_ORDER = [
  EM_CRIACAO,
  EM_ANALISE,
  AGUARDANDO_INSPECAO,
  INSPECAO_EM_ENVIO,
  EM_INSPECAO,
  INSPECAO_ENVIADA_PARCIAL,
  INSPECAO_SYNC_ERROR,
  ERRO_AO_ENVIAR_INSPECAO,
  INSPECAO_FINALIZADA,
  AGUARDANDO_DIGITACAO,
  EM_DIGITACAO,
  DIGITACAO_FINALIZADA,
  EXECUTADA_GDIS,
  FINALIZADA,
  CANCELADA,
];

export const STATUS_OPTIONS_DESCRIPTION = {
  EM_CRIACAO: 'Em Criação',
  EM_ANALISE: 'Em Análise',
  AGUARDANDO_INSPECAO: 'Aguardando Inspeção',
  EM_INSPECAO: 'Em Inspeção',
  INSPECAO_ENVIADA_PARCIAL: 'Inspeção Enviada Parcial',
  INSPECAO_EM_ENVIO: 'Inspeção em Envio',
  INSPECAO_SYNC_ERROR: 'Inspeção com Erro de Envio',
  ERRO_AO_ENVIAR_INSPECAO: 'Erro ao enviar Inspeção',
  INSPECAO_FINALIZADA: 'Inspeção finalizada',
  INSPECAO_ENVIADA_COM_SUCESSO: 'Enviada com Sucesso',
  AGUARDANDO_DIGITACAO: 'Aguardando Digitação',
  EM_DIGITACAO: 'Em Digitação',
  DIGITACAO_FINALIZADA: 'Digitação Finalizada',
  EXECUTADA_GDIS: 'Executada no GDIS',
  FINALIZADA: 'Finalizada no GDIS',
  CANCELADA: 'Cancelada',
};

export const NSIR_CLOSED_STATUSES = [FINALIZADA, CANCELADA];
export const NSIR_POST_GDIS_STATUSES = [EXECUTADA_GDIS, FINALIZADA];

export const isNsirClosed = status => NSIR_CLOSED_STATUSES.includes(status);
export const isNsirReadOnly = status => isNsirClosed(status) || status === EXECUTADA_GDIS;

export const statusDescription = status => STATUS_OPTIONS_DESCRIPTION[status];
export const canCloneAuditoriaFaixa = status => [EM_CRIACAO, AGUARDANDO_INSPECAO].indexOf(status) > -1;

/** Default select options derived from the ordered enum (id + nome). */
export const getNsirStatusSelectOptions = () =>
  NSIR_STATUS_OPTIONS_ORDER.map(id => ({
    id,
    nome: STATUS_OPTIONS_DESCRIPTION[id] || id,
  }));
